import { Markdown } from 'components';
import { STATUS } from 'consts/statuses';
import waiverBgImg from 'img/waiver-bg.png';
import { useWaiver } from './useWaiver';

export function Waiver() {
	const { status, t } = useWaiver();
	return (
		<div className="waiver">
			<div className="container">
				<div className="row">
					<div className="col-12 col-md-6 d-flex flex-column justify-content-center">
						{STATUS.SUCCESS === status && (
							<div className="txt-fix text-white">
								<p className="display-3">{t('waiver_title')}</p>
								<Markdown>{t('waiver_main')}</Markdown>
							</div>
						)}
						{STATUS.ERROR === status && (
							<p className="txt-fix display-3 text-primary">{t('default_api_error')}</p>
						)}
						{STATUS.NO_ID === status && (
							<p className="txt-fix display-3 text-primary">{t('waiver_no_token_error')}</p>
						)}
					</div>
					<div className="d-none d-md-block col-6 mt-3">
						<img alt="" className="img-fluid" src={waiverBgImg} />
					</div>
				</div>
			</div>
		</div>
	);
}
